export function SideColumn(props: {
  children?: React.ReactNode
  side: 'left' | 'right'
}) {
  const side = props.side == 'left' ? 'nav' : 'totalByTask'
  return <div className={`contents grid-in-${side}`}>{props.children}</div>
}
